import {
  Card,
  Heading,
  IconTick,
  List,
  Stack,
  Text,
} from 'braid-design-system';

import type { ListingProduct } from 'src/generated/graphql';

interface EmailBoostProductDetailsProps {
  product: ListingProduct;
}

export const EmailBoostProductDetails = (
  props: EmailBoostProductDetailsProps,
) => (
  <Card data={{ testid: 'email-boost-product-details' }}>
    <Stack space="large">
      <Heading level="4" component="h3">
        Email boost your ads to reach more buyers
      </Heading>

      <List type="icon" icon={<IconTick tone="positive" />}>
        {[
          'Your ad is featured at the top of our recommended business emails which we send daily to buyers',
          'Your ad remains boosted for the life of your ad',
        ].map((feature, i) => (
          <Text key={i}>{feature}</Text>
        ))}
      </List>

      <Text size="large" data={{ testid: 'email-boost-product-details-price' }}>
        ${props.product.cost / 100} + GST
      </Text>
    </Stack>
  </Card>
);
